import type { PillTone } from "@/components/ui/pill";
import type { SensorSummary } from "@/features/sensors/hooks";

type SensorStatus = SensorSummary["status"];
type SensorState = SensorSummary["state"];

// Eixo conectividade (`status`) — cor + dot + rótulo.
export const SENSOR_STATUS_LABEL: Record<SensorStatus, string> = {
  ONLINE: "Online",
  OFFLINE: "Offline",
  NO_READING: "Sem leitura",
  INCONSISTENT: "Inconsistente",
};

export const SENSOR_STATUS_TONE: Record<SensorStatus, PillTone> = {
  ONLINE: "success",
  OFFLINE: "danger",
  NO_READING: "neutral",
  INCONSISTENT: "warning",
};

// Eixo cadastro (`state`).
export const SENSOR_STATE_LABEL: Record<SensorState, string> = {
  AVAILABLE: "Disponível",
  LINKED: "Vinculado",
  NO_READING: "Sem leitura",
  INCONSISTENT: "Inconsistente",
};

export const SENSOR_STATE_TONE: Record<SensorState, PillTone> = {
  AVAILABLE: "neutral",
  LINKED: "brand",
  NO_READING: "neutral",
  INCONSISTENT: "warning",
};
